// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Spain from '../_raw/flag/icon_flag_spain.png';

export default () => <img src={Spain} alt="Spain" />;
